import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const TemplateVariablesSelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  background: ${colors.white};
  border-radius: 8px;
  border: 1px solid ${colors.grey444};
  max-height: 240px;
  width: 220px;
  overflow-y: auto;

  .variable-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2px;
    border-radius: 8px;
    padding: 8px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    cursor: pointer;

    .eye-icon path {
      stroke: ${colors.grey11} !important;
      transition: stroke 0.2s ease;
    }

    &:hover {
      background-color: ${colors.primaryLight};
      color: ${colors.primary};

      .eye-icon path {
        stroke: ${colors.primary} !important;
      }
    }
  }
  /* .eye-icon path {
    stroke: ${colors.grey11};
  }
  .variable-item:hover .eye-icon path {
    stroke: ${colors.primary};
  } */
  .variable-item.disabled {
    cursor: default;
    color: ${colors.grey11};
    :hover {
      background-color: ${colors.white};
    }
  }
  .other-variables {
    color: ${colors.grey11};
    &:hover {
      background-color: ${colors.primaryLight};
      color: ${colors.primary};
      svg {
        path {
          stroke: ${colors.primary};
        }
      }
    }
  }
  .section-name {
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    color: ${colors.grey11};
  }
  .divider {
    width: 100%;
    border: 1px solid ${colors.grey444};
    margin-block: 4px;
  }
`;
